export default __webpack_public_path__ + "static/media/createCollections@2x.26b8e6df.png";